<template>
  <main v-if="schoolInfo.id">
    <div class="top-banner">
      <el-image class="institution-logo" :src="schoolInfo.logo" fit="cover" />
      <h1>
        <i class="el-icon-mic" />
        <span>{{ schoolInfo.live_title }}</span>
        <i class="el-icon-mic" />
      </h1>
    </div>
    <div class="container">
      <Filters :type-list="typeList" :year-list="yearList" @search="getSearch" />
      <div class="list-container">
        <ListCard v-for="item in liveList" :key="item.id" :card-data="item" />
      </div>
      <div class="pagination-ara">
        <!-- <el-pagination background layout="prev, pager, next" :total="1000" /> -->
      </div>
    </div>
    <div class="bottom-banner">
      <span>版权所有&copy;{{ schoolInfo.name }} 斯奈特提供在线技术支持</span>
    </div>
  </main>
</template>

<script>
import Filters from './components/Filters'
import ListCard from './components/ListCard'
import { getSchoolInfo, getLiveList } from '@/api/customer'
export default {
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'keywords',
          content: '',
        },
        {
          name: 'description',
          content: '',
        },
      ],
    }
  },
  components: {
    Filters,
    ListCard,
  },
  data() {
    return {
      schoolId: 0,
      schoolInfo: {},
      yearList: [],
      year: 0,
      typeList: [],
      type: 0,
      searchForm: {
        year: '',
        type: '',
        status: '',
        keyword: '',
      },
      liveList: [],
      currentPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    // 动态设置title
    title() {
      return this.schoolInfo.live_title || '招生直播宣讲会';
    }
  },
  created() {
    this.loading = true
    this.schoolId = this.$route.params.id
    getSchoolInfo({ id: this.schoolId })
      .then((res) => {
        if (res.statusCode === 0) {
          this.schoolInfo = res.data.school
          this.typeList = [{ id: 0, name: '全部' }, ...res.data.type]
          this.yearList = ['全部', ...res.data.years]
          this.getLives()
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$message.error('请求列表发生错误')
      })
  },
  methods: {
    async getLives() {
      this.loading = true
      const params = {
        schoolId: this.schoolId,
        year: this.searchForm.year,
        type: this.searchForm.type,
        status: this.searchForm.status,
        keyword: this.searchForm.keyword,
        page: this.currentPage,
        size: this.pageSize,
      }
      const { data } = await getLiveList(params)
      this.liveList = data
      this.loading = false
    },
    getSearch(data) {
      this.searchForm = data
      this.getLives()
    },
  },
}
</script>

<style lang="less" scoped>
main {
  width: 100%;

  .top-banner {
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    background-image: linear-gradient(90deg, rgb(193, 193, 193),rgb(107, 107, 107)),linear-gradient(157.5deg, rgb(0, 165, 230) 0%, rgb(0, 165, 230) 39%,rgb(17, 149, 218) 39%, rgb(17, 149, 218) 56%,rgb(35, 132, 206) 56%, rgb(35, 132, 206) 60%,rgb(52, 116, 195) 60%, rgb(52, 116, 195) 68%,rgb(70, 99, 183) 68%, rgb(70, 99, 183) 86%,rgb(87, 83, 171) 86%, rgb(87, 83, 171) 100%),linear-gradient(135deg, rgb(0, 165, 230) 0%, rgb(0, 165, 230) 39%,rgb(17, 149, 218) 39%, rgb(17, 149, 218) 56%,rgb(35, 132, 206) 56%, rgb(35, 132, 206) 60%,rgb(52, 116, 195) 60%, rgb(52, 116, 195) 68%,rgb(70, 99, 183) 68%, rgb(70, 99, 183) 86%,rgb(87, 83, 171) 86%, rgb(87, 83, 171) 100%); background-blend-mode:overlay,overlay,normal;

    .institution-logo {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
    }

    h1 {
      color: #ffffff;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 420px);

    .list-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
    }

    .pagination-ara {
      padding: 40px 0 60px;
      text-align: center;
    }
  }

  .bottom-banner {
    width: 100%;
    height: 120px;
    border-top: 20px solid #66d5c8;
    background: linear-gradient(to bottom, #4b71ff, #2b5bf4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
